'use es6';

import { fromJS } from 'immutable';
import * as colors from '../../../constants/colors';
export const defaultPieSeriesOptions = fromJS({
  showInLegend: true,
  innerSize: 0,
  dataLabels: {
    enabled: true,
    connectorColor: colors.TEXT_INACTIVE,
    connectorPadding: 10,
    connectorWidth: 2,
    softConnector: false,
    overflow: 'none',
    distance: 20,
    useHTML: true
  }
});